<template>
  <div>
    <div class="header">
      <h1 class="page-title">发货地址管理</h1>
    </div>
    <el-card class="box-card">
      <div class="main">
        <el-button type="primary" size="medium" id="addAddress" @click="addaddress()">添加地址</el-button>

        <el-table
          v-loading="loading"
          :data="AddressList"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column width="130" :resizable="false" prop="shopping_name" label="姓名"></el-table-column>
          <el-table-column :resizable="false" prop="address" label="地区"></el-table-column>
          <el-table-column :resizable="false" prop="query" label="详细地址"></el-table-column>
          <el-table-column width="120" :resizable="false" prop="shopping_phone" label="手机号码"></el-table-column>
          <el-table-column width="250" :resizable="false" prop="order_no" label="操作">
            <template slot-scope="scope">
              <div class="caozuo" v-if="scope.row.def==0">
                <el-tooltip
                  class="item"
                  effect="light"
                  content="设置默认地址后下单默认会选择该地址"
                  placement="bottom"
                  :enterable="false"
                >
                  <el-link type="primary" @click="settingAddress(scope.row.id)">设为默认</el-link>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="修改地址信息"
                  placement="bottom"
                  :enterable="false"
                >
                  <el-link type="success" @click="editShowDialog(scope.row)">修改地址</el-link>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="此操作将删除该地址"
                  placement="bottom"
                  :enterable="false"
                >
                  <el-link type="danger" @click="delAddress(scope.row.id)">删除</el-link>
                </el-tooltip>
              </div>

              <div class="caozuo" v-else>
                <el-link type="danger" @click="quAddress(scope.row.id)">取消默认</el-link>
                <el-link type="info">默认地址</el-link>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="修改地址信息"
                  placement="bottom"
                  :enterable="false"
                >
                  <el-link type="success" @click="editShowDialog(scope.row)">修改</el-link>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="此操作将删除该地址"
                  placement="bottom"
                  :enterable="false"
                >
                  <!-- <el-link type="danger" @click="delAddress(scope.row.id)">删除</el-link> -->
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          @close="dialogClose"
          :visible.sync="dialogVisible1"
          class="dia-title"
          title="地址管理"
          width="40%"
        >
          <el-form
            style="margin-top:10px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="收货人姓名" prop="shopping_name">
              <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="shopping_phone">
              <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的电话或者手机号码"></el-input>
            </el-form-item>
            <v-distpicker
              id="distpicker"
              style="margin:0 0 10px 100px"
              @selected="onSelected"
              :province="adr.province"
              :city="adr.city"
              :area="adr.area"
            ></v-distpicker>
            <el-form-item label="详细地址" prop="query">
              <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" class="diz">添加地址</el-button>
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'

export default {
  components: {
    VDistpicker
  },
  data() {
    return {
      dialogVisible1: false,
      loading: true,
      ruleForm: {
        // 省id
        provice_id: '',
        // 省市区id
        address: [],
        // 详细地址信息
        query: '',
        // 名字
        shopping_name: '',
        ext_number: '',
        // 手机号码
        shopping_phone: '',
        token: window.localStorage.getItem('token'),
        id: ''
      },
      flag: 0,
      AddressList: [],
      rules: {
        shopping_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        shopping_phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 7, max: 15, message: '请核对手机号码', trigger: 'blur' }
        ],
        query: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      adr: {
        province: 0,
        city: 0,
        area: 0
      }
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryAddress()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    //   获取选择地址信息
    onSelected(data) {
      this.ruleForm.address = []
      this.ruleForm.provice_id = ''
      this.ruleForm.provice_id = data.province.code
      for (let key in data) {
        this.ruleForm.address.push(data[key].code)
      }

      // console.log(this.ruleForm)
    },
    // 验证信息填写是否完全
    submitForm(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
      }
      this.$refs[formName].validate(async valid => {
        if (!valid) {

        } else {
          if (!this.ruleForm.provice_id || !this.ruleForm.address) {
            this.$message('请选择详细地区信息', '提示')
            return
          }
          // console.log(this.ruleForm.address)

          this.ruleForm.address = this.ruleForm.address.join(',')
          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }
          // 添加地址
          if (this.flag == 0) {
            const { data: res } = await this.$http({
              method: 'post',
              url: 'api/fahuoaddress/addaddress',
              data: param
            })
            if (res.code == 1) {
              this.$confirm('添加地址信息成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            } else {
              this.$confirm('添加地址失败', '提示')
            }
          } else if (this.flag == 1) {
            const { data: resu } = await this.$http({
              method: 'post',
              url: 'api/fahuoaddress/editaddress',
              data: param
            })
            if (resu.code == 1) {
              this.$confirm('修改地址成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            }
          }
        }
      })
    },
    // 递归排序
    compare(property) {
      return function(a, b) {
        return b[property] - a[property]
      }
    },
    // 添加地址
    addaddress() {
      this.flag = 0
      this.dialogVisible1 = true
      $('.diz span').text('添加地址')
    },
    // 点击编辑地址
    editShowDialog(data) {
      this.adr.province = data.address_id[0] - 0
      this.adr.city = data.address_id[1] - 0
      this.adr.area = data.address_id[2] - 0
      this.ruleForm.shopping_name = data.shopping_name
      this.ruleForm.shopping_phone = data.shopping_phone
      this.ruleForm.query = data.query
      this.ruleForm.id = data.id
      this.dialogVisible1 = true
      this.flag = 1
      $('.diz span').text('修改地址')
    },
    // 设置默认地址
    async settingAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/fahuoaddress/defaddress',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('设置默认地址成功', '提示')
        this.queryAddress()
      }
    },
    // 删除地址
    async delAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/fahuoaddress/deladdress',
        data: param
      })
      // console.log(res)
      if (res.code == 1) {
        this.$confirm('删除成功', '提示')
      }
      this.queryAddress()
    },
    // quxiao地址
    async quAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/fahuoaddress/quaddress',
        data: param
      })
      // console.log(res)
      if (res.code == 1) {
        this.$confirm('取消成功', '提示')
      }
      this.queryAddress()
    },
    // 查询地址列表
    async queryAddress() {
      let token = window.localStorage.getItem('token')
      if (token) {
        let param = new URLSearchParams()
        param.append('token', token)
        param.append('linmt', 100)
        const { data: res } = await this.$http({
          method: 'post',
          url: '/api/fahuoaddress/index',
          data: param
        })
        this.loading = false
        if (res.code == 1) {
          this.AddressList = res.data.sort(this.compare('def'))
        } else {
          this.AddressList = []
        }
      }
    },
    dialogClose() {
      window.history.go(0)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.box-card {
  width: 80%;
  min-height: 750px;
  margin-left: 50px;
  .page-title {
    font-size: 22px;
  }
  .main {
    .el-link {
      margin-right: 10px !important;
    }
  }
}
</style>
